import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';

export const messagePhone = createAction(types.MESSAGE_PHONE, (botPhone: { phone: string, lastName?: string, name: string, isAdmin: boolean }) => ({
    payload: botPhone,
}));
